import { Badge } from '@/components/ui/badge';
import type { Placement } from '../hooks/usePlacements';

/** "Acme Corp › HQ", tagged when the division is an MSP customer. */
export default function PlacementLabel({ placement }: { placement: Placement }) {
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      <span>{placement.path}</span>
      {placement.isCustomer ? (
        <Badge variant="secondary" className="font-normal text-[11px] px-1.5 py-0">
          Customer
        </Badge>
      ) : null}
    </span>
  );
}
